import './index.css';

export default {
  name: 'AaMap',
  props: {
    id: { type: String, default: () => (`a-amap-${Math.random().toString().substring(2)}`) },
    mapKey: { type: String, default: () => '7e9401417e66edab320680eb027b6d47' },
    mapStyle: { type: String, default: () => 'grey' },
  },
  data() {
    return ({
      scriptId: `${this.id}-script`,
      loading: true,
      map: null,
      district: null,
      polygons: [],
      levelOption: [
        { label: '省份', value: 'province' },
        { label: '城市', value: 'city' },
        { label: '区县', value: 'district' },
      ],
      level: null,
      site: null,
    });
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    onload() { // 加载依赖
      return new Promise((resolve) => {
        const script = document.createElement('script');
        script.id = this.scriptId;
        script.src = `https://webapi.amap.com/maps?v=2.0&plugin=AMap.DistrictSearch&key=${this.mapKey}`;
        document.head.appendChild(script);
        script.onload = () => resolve(true);
      });
    },
    create() { // 创建地图
      this.onload().then((success = false) => {
        if (success && AMap) {
          const map = new AMap.Map(this.id, {
            zoom: 10,
            center: [116.397428, 39.90923],
            mapStyle: this.mapStyle.startsWith('amap://styles/') ? this.mapStyle : (`amap://styles/${this.mapStyle}`),
          });
          map.on('complete', () => {
            this.map = map;
            this.$nextTick(() => {
              this.$emit('onload', this.map);
              this.$nextTick(() => this.loading = false);
            });
          });
        }
      });
    },
    border() { // 绘制边界

    },
    marker() { // 创建标记 

    },
    locate() { // 定位移动
      if (!this.district) {
        //实例化DistrictSearch
        var option = {
          subdistrict: 0,   //获取边界不需要返回下级行政区
          extensions: 'all',  //返回行政区边界坐标组等具体信息
          level: 'district'  //查询行政级别为 市
        };
        this.district = new AMap.DistrictSearch(option);
      }
      console.log('查看时间----------------------->>', this.district, this.level, this.site);
      //行政区查询
      this.district.setLevel(this.level)
      this.district.search(this.site, (status, result) => {
        this.map.remove(this.polygons)//清除上次结果
        this.polygons = [];
        console.log('查看边界数据---------------------------->>', result);
        const bounds = result.districtList[0].boundaries;
        if (bounds) {
          for (let i = 0, l = bounds.length; i < l; i++) {
            //生成行政区划polygon
            const polygon = new AMap.Polygon({
              strokeWeight: 1,
              path: bounds[i],
              fillOpacity: 0.4,
              fillColor: '#80d8ff',
              strokeColor: '#0091ea'
            });
            this.polygons.push(polygon);
          }
        }
        this.map.add(this.polygons)
        this.map.setFitView(this.polygons); //视口自适应
      });
    },
    cancel() { // 取消标记

    },
    remove() { // 删除标记

    },
    revoke() { // 销毁地图
      if (this.map) {
        this.map.destroy();
        this.map = null;
      }
      const script = document.getElementById(this.scriptId);
      script && (script.parentNode.removeChild(script));
    },
  },
  render() {
    const { width = '100%', height = '100%' } = this.$attrs;
    return (
      <div class="a-amap" v-loading={this.loading} style={{ width, height }}>
        <div class="a-amap-main" id={this.id} />
        <div class="a-amap-tool">
          <label style='color:grey'>行政区边界查询</label>
          <div class="input-item">
            <div class="input-item-prepend">
              <span class="input-item-text" >行政级别</span>
            </div>
            <select v-model={this.level}>
              {this.levelOption.map((a, b) => (<option key={b} value={a.value}>{a.label}</option>))}
            </select>
          </div>
          <div class="input-item">
            <div class="input-item-prepend">
              <span class="input-item-text" >名称/adcode</span>
            </div>
            <input id='district' type="text" v-model={this.site} />
          </div>
          <input id="draw" type="button" class="btn" value="查询" on-click={() => this.locate()} />
        </div>
      </div>
    );
  }
}